import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBookmark: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bookmark, banner, flag, tag"><path d="M7.75 2C5.67893 2 4 3.67893 4 5.75V20.2515C4 21.6527 5.56475 22.4857 6.72719 21.7032L10.7436 18.9997C11.5032 18.4885 12.4968 18.4885 13.2564 18.9998L17.2728 21.7032C18.4353 22.4857 20 21.6527 20 20.2515V5.75C20 3.67893 18.3211 2 16.25 2H7.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBookmark;
